<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.fiscalization.event-register-dialog.title' | translate"
		id="fiscalization-registry-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<div class="align--form">
			<skl-grid-ins
				[dataSource]="viewModel.gridDataSource$"
				id="fiscalization-registry-dialog-grid"
				[columns]="viewModel.gridColumns$"
				[options]="viewModel.gridOptions">
				<ng-template [sklGridTemplate]="'fiscalDeviceRegistryDialogGridCellStatus'" let-row="row" let-col="col">
					<div
						[tooltip]="getStatusText(row.status)">
						<i [ngClass]="getStatusClassNames(row.status)"></i>
					</div>
				</ng-template>
			</skl-grid-ins>
		</div>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="fiscalization-registry-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.fiscalization.event-register-dialog.buttons.close' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>
